module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/按钮-媒体播放按钮.2132a.png";